import React from 'react';
import { __ } from '@wordpress/i18n';
import { BlockControls } from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { getBlockById, buildCustomizerUrl } from './utils';

const FeedToolbar = ({ id, attributes }) => {
    const { feedId } = attributes;
    const block = getBlockById(id);

    if (!feedId || !block?.customizerPage) return null;

    return (
        <BlockControls>
            <ToolbarGroup>
                <ToolbarButton
                    icon="admin-customizer"
                    label={__('Customizer', 'sb-common')}
                    onClick={() => window.open(
                        buildCustomizerUrl(block.customizerPage, feedId),
                        '_blank'
                    )}
                    showTooltip
                />
            </ToolbarGroup>
        </BlockControls>
    );
};

export default FeedToolbar;
